// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"793":"cab8e9bf","901":"cab8e9bf","940":"0acaee5b"}[chunkId] + ".chunk.css";
};